import React, { useEffect, useState } from "react";

export function Agenda({ className, children }) {
  return (
    <section className={`${className} bg-purple`}>
      <div className="container pb-5">{children}</div>
    </section>
  );
}

export function AgendaDay({ title, children }) {
  return (
    <div className="mt-5">
      <div className="text-center mb-3 agenda-day">
        <h1 className="color-white">{title}</h1>
      </div>
      <div className="banded-rows">{children}</div>
    </div>
  );
}

export function AgendaEvent({ time, children }) {
  return (
    <div className="row align-items-baseline">
      <div className="col-lg-2 p-lg-0 offset-lg-1 text-nowrap flex-shrink-1 flex-grow-0">
        <span className="time">{time}</span>
      </div>
      <div className="col p-lg-0 flex-grow-1 flex-shrink-0">{children}</div>
    </div>
  );
}

export function AgendaSpeaker({ name, company, isKeynote, className = "" }) {
  const [imageSrc, setImageSrc] = useState("/img/portraits/portrait-tba.webp");
  const isComingSoon = name?.startsWith("Coming Soon");

  useEffect(() => {
    if (!name || isComingSoon) return;
    const formattedName = name
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-");
    const imagePath = `/img/portraits/portrait-${formattedName}.webp`;
    const img = new Image();
    img.src = imagePath;
    img.onload = () => setImageSrc(imagePath);
    img.onerror = () => setImageSrc("/img/portraits/portrait-tba.webp");
  }, [name, isComingSoon]);

  return (
    <span className={`agenda-speaker${className ? ` ${className}` : ""}`}>
      <div
        className="agenda-speaker-img"
        style={{ backgroundImage: `url(${imageSrc})` }}
      ></div>
      <span className="agenda-speaker-info">
        {isKeynote && (
          <strong className="color-white-60">Keynote Speaker</strong>
        )}
        <h2>{isComingSoon ? "Coming Soon" : name}</h2>
        {company && !isComingSoon && (
          <span className="company white-60">{company}</span>
        )}
      </span>
    </span>
  );
}

export function AgendaBreakout({ title, count }) {
  if (!count) return null;
  return (
    <div className="breakout-row">
      <span className="color-white-60">Breakout Session {count}</span>
      <h2 className="mb-2">{title}</h2>
    </div>
  );
}
const numberWords = [
  "Zero",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
];

function toWords(count) {
  const num = Number(count);
  if (Number.isInteger(num) && num >= 0 && num < numberWords.length) {
    return numberWords[num];
  }
  return count; // fallback: render whatever was passed as-is
}

export function AgendaBreakoutLabel({ count }) {
  if (!count) return null;
  return (
    <div className="breakout-row">
      <strong className="color-white">Breakout Session {toWords(count)}</strong>
    </div>
  );
}
